const checkoutV3Prefix = 'CheckoutV3';

const CHECKOUT_V3 = Object.freeze({
  DELIVERY: {
    COMPLETING_ORDER_ERROR_DELIVERY: `${checkoutV3Prefix} Completing Order Error Delivery`,
  },
  PAYMENT: {
    COMPLETING_ORDER_ERROR_PAYMENT: `${checkoutV3Prefix} Completing Order Error Payment`,
    COMPLETING_ORDER_ERROR_GENERAL: `${checkoutV3Prefix} Completing Order Error General`,
  },
});

const PRODUCT_PAGE_PREFIX = 'ProductPage';

const PRODUCT_PAGE = Object.freeze({
  CTA_SUBNAV: {
    CLICK_PRIMARY: `${PRODUCT_PAGE_PREFIX} CTA Subnav Click Primary`,
    CLICK_LINK: `${PRODUCT_PAGE_PREFIX} CTA Subnav Click Link`,
  },
});

const CDP_EVENT_NAMES = {
  CHECKOUT_V3,
  PRODUCT_PAGE,
};

export default CDP_EVENT_NAMES;
